import React from 'react';
import { Route, Switch } from 'react-router-dom';
import '../../css/Warehouse.css';
import FormAddPartner from '../../partner/FormAddPartner';

const Partner = ({ match }) => {
  return (
    <div>
      <Switch>
        <Route
          exact
          path={`${match.url}`}
          component={() => <FormAddPartner match_parent={match} />}
        />
      </Switch>
    </div>
  );
};

export default Partner;
